define('app/components/play_template',[

  'lodash',

  'app.env',
  'app/config/constants',

  'app/helper/copy',
  'app/helper/textreader.se',
  'app/app.utils',

  'app/helper/play.language',

  'app/providers/sePlayPrv',
  'app/components/ractivejs.play',

  'app/components/play_template.element',

  'app/helper/logging.se',
  'app/helper/connectionstatus.se',

  'plugins/jquery/jquery.sticky'

], function (
  _,
  ENV,
  CONSTANTS,
  Copy,
  TextReader,
  UTILS,
  language,
  sePlayPrv,
  BaseView,
  PlayElementComponent,
  seLogging,
  connectionStatus,
  _jqSticky
) {
  var console = window.console,
    Date = window.Date

  var LOG_LABEL = 'PLAY VIEW'

  var loadr = loadr || window.loadr // initialized in main template via script
  if (!loadr) console.error(LOG_LABEL, 'loadr missing!')

  // ---- window.SePlay utilities ------------------------------------------------------

  var SePlay = window.SePlay = window.SePlay || {}
  var
    PlayConfirmModal = BaseView.extend({
      template: '#PlayConfirmModal-template',
      data: function () {
        return {
          modalContent: ''
        }
      },

      _showModal: function () {
        var _this = this
        $('#modal_play-confirm.modal', _this.el).modal('show')
      },

      _modalStatus: null,
      doConfirmModal: function () {
        var _this = this

        if (!_this._modalStatus) return

        _this._modalStatus.resolve()
      },

      oncomplete: function () {
        var _this = this

        SePlay.confirm = function (message) {
          _this.set('modalContent', message)

          _this._modalStatus = $.Deferred()

          _this._showModal()

          return _this._modalStatus.promise()
        }
      }
    })

  SePlay.TextReader = TextReader

  // ---- play view ------------------------------------------------------------------------
  var PlayView = BaseView.extend({
    // settings
    el: '#content-block',
    template: '#template-content-block',
    data: function () {
      return {
        CONST: CONSTANTS,
        STATUS: CONSTANTS.STATUS,
        ENV: ENV,
        $ui: {},

        status: CONSTANTS.STATUS.NOT_LOADED,

        play: null,
        playError: null,
        playErrorStr: null,
        index: null,
        page: null
      }
    },

    // decorators & components
    decorators: {},
    components: {
      PlayElement: PlayElementComponent,
      PlayConfirmModal: PlayConfirmModal
    },

    // helper
    delayingSavingStatus: false,
    _delayStatus: function (newStat) {
      var _this = this,
        delayByMs = 125

      if (newStat === CONSTANTS.STATUS.SAVING) { // show instantly
        _this._showSpinner(true)
        _this.delayingSavingStatus = $.Deferred()

        setTimeout(function () {
          if (_this.delayingSavingStatus) {
            _this.delayingSavingStatus.resolve()
            _this.delayingSavingStatus = false
          }
        }, delayByMs)

      } else { // show delayed
        if (_this.delayingSavingStatus) {
          _this.delayingSavingStatus.done(function () {
            _this._showSpinner(false)
          })
        } else {
          _this._showSpinner(false)
        }
      }
    },

    _showSpinner: function (doShowSpinner) {
      var _this = this

      if (doShowSpinner === undefined)
        doShowSpinner = true // true by default

      _this.set('displaySpinner', !!doShowSpinner)
    },

    _waitForNewElementsToBeComplete: function () {
      var _this = this

      var elementViews = _this.findAllComponents('PlayElement'),
        elementsComplete = $.Deferred()

      _this.set('status', CONSTANTS.STATUS.LOADING)

      UTILS.waitFor(function () {

        return _.reduce(elementViews, function (val, eview) {
          return val && eview.get('status') >= CONSTANTS.STATUS.LOADED // LOADED;
        }, true)

      }, ENV.async_timeout_seconds * 1000).then(function () {
        // trigger script loading on elementViews

        _this.set('status', CONSTANTS.STATUS.LOADED)
        _.each(elementViews, function (eview) {
          eview.fire('view.ready')
        })

        UTILS.waitFor(function () {

          return _.reduce(elementViews, function (val, eview) {
            return val && eview.get('status') === CONSTANTS.STATUS.COMPLETE // COMPLETE;
          }, true)

        }, ENV.async_timeout_seconds * 1000).then(function () {
          _this.set('status', CONSTANTS.STATUS.READY)
          elementsComplete.resolve()
        }).fail(function () {

          seLogging.error_plain('Server connection timed out', 'Please make sure you have a stable internet ' +
            'connection, then reload this page', 'Reload', function () {
            window.location.reload()
          })

          console.warn(LOG_LABEL, 'Timeout for loading inline scripts')
        })

      }).fail(function () {

        seLogging.error_plain('Connection timed out', 'Please make sure you have a stable internet ' +
          'connection, then reload this page', 'Reload', function () {
          window.location.reload()
        })

        console.warn(LOG_LABEL, 'Timeout for loading linked scripts')
      })

      return elementsComplete.promise()
    },

    _setupOnErrorHandling: function () {
      var _this = this

      var
        onError = function (err) {

          if (window.onPlayError) { // used as interface for testing and simulation

            var errStr = (err.message || err.description) + ' (' + (err.stack || (err.error && err.error.stack ? err.error.stack : 'no stacktrace')) + ')'

            onPlayError(errStr)
          }

          if (err.details && err.details.res) {
            // API Error
            if (err.details.res.status === 'timeout') {
              // failed but recoverable by user
              _this._showSpinner(false)
              return

            } else if (err.details.res.status === 'retry') {
              // dont fail yet. wait for retry.
              return
            }
          }

          // clear toasties
          seLogging.dismissAll()

          var
            playErrorObj = new Object(err),
            playErrorStr = (function () {
              var obj = new Object(playErrorObj)
              // if(sePlayPrv.pget("header.isPreview")){
              //     obj.info = btoa(JSON.stringify(obj.info))
              // }
              return JSON.stringify(obj)
            }())

          _this.set('playError', playErrorObj)
          _this.set('playErrorStr', playErrorStr)
          sePlayPrv.setStatus(CONSTANTS.STATUS.FAILED)

          // if(_this.get("play.header.isPreview")){
          //     // dont redirect on error in preview
          //     return;
          // }
          //
          //

          // setTimeout(function(){ // small delay to let logging send logs to server
          //
          //     // clear toasties
          //     seLogging.dismissAll();
          //
          //     //// first: try reload
          //     //if(seLogging.tryReloadingPage()){
          //     //
          //     //    loadr.progress("One moment please ...");
          //     //    // delayed reload triggered.
          //     //
          //     //    return;
          //     //}
          //     //
          //     //// if that fails -> redirect to exit.
          //
          //     _this._redirect("An error occured ...");
          //
          // }, 1500);

        }

      seLogging.on('error', onError)

      connectionStatus.on('status', function (mdl, status) {
        if (status === connectionStatus._CON.FAILED) {
          _this._showSpinner(false)
        }
      })

    },

    _logError: function () {

    },

    _redirect: function (message, err) {

      message = message || 'Redirecting ...'

      loadr.progress(message)

      var redirectToUri = sePlayPrv.pget('header.forcedRedirect') || sePlayPrv.pget('header.errorUri')

      // redirect to error uri
      location.href = redirectToUri
    },

    _setTitle: function () {
      var _this = this,
        titleStr = _this.get('play.title')

      $('title').text(titleStr)

    },

    _updateCurrentPageNr: function (newPageId) {

      var newPageNr = 1,
        pages = sePlayPrv.index.pages,
        page

      while (!!(page = pages.at(newPageNr - 1)) && page.get('id') != newPageId) {
        newPageNr++
      }

      if (!page)
        return

      sePlayPrv.set('pageNr', newPageNr)

    },

    _rewriteUrl: function () {
      var _this = this,
        docTitle,
        newUrl

      if (_this.get('play.header.isPreview') && !_this.get('play.header.hideControls')) {
        docTitle = document.querySelector('title').innerText
        newUrl = ENV.play_api_url + '?' + 'PLAYSID=' + ENV.play_sid + '&page_number=' + sePlayPrv.get('pageNr')
        window.history.pushState(null, docTitle, newUrl)
      }

      //disabled until we can get the front end posts working
      //
      //var _this = this,
      //docTitle = document.querySelector('title').innerText;
      //history.pushState(null, docTitle, location.href.replace(/(PLAYSID=[a-z0-9]+&?)/i,""));
      //history.pushState(null, docTitle, location.href.replace(/bin\/play.pl.*$/i,""));    // remove the entire play ur

    },

    // actions
    doSendForm: function (formElm) {
      var _this = this

      if (sePlayPrv.pget('header.isExample')) {
        // do not send
        return
      }

      var $form = $(formElm || 'form[name="play"]'),
        formDataArr = $form.serializeArray(),
        formData = {},
        defaultUnselectedValue = _this.get('play.header.unselectedValue')

      if (!$form.is('[name="play"]')) {
        // this is not the play form ... do not send.
        return
      }

      // set unselected checkboxes to default-value (e.g. 1)
      var $fieldsCheckboxesUnselected = $('input[type=checkbox]', $form).not(':checked')

      $fieldsCheckboxesUnselected.each(function (i, elm) {
        formDataArr.push({
          name: $(elm).attr('name'),
          value: defaultUnselectedValue
        })
      })

      // get multiple-select fields handled correctly
      var $multipleSelectFieldOptions = $('select[multiple] option', $form)

      $multipleSelectFieldOptions.each(function (i, elm) {
        var $opt = $(elm),
          varName = $opt.attr('data-name'),
          varVal = $opt.attr('data-value'),
          isSelected = !!$opt[0].selected

        formDataArr.push({
          name: varName,
          value: isSelected ? varVal : defaultUnselectedValue
        })

      })

      _.forEach(formDataArr, function (val) {

        if (val.name.match(/_other$/)) {
          var $otherElm = $('input[name="' + val.name + '"]'),
            $rel_inputElm = $otherElm.closest('.se_item').find([
              '.se_level_other input[type=radio]',
              '.se_level_other input[type=checkbox]',
              'select:not([multiple]) option[data-option-other]',
              'select[multiple] option[data-option-other]'].join(', ')),
            hasRelInputElm = !!$rel_inputElm.length,
            hasOther = !!$rel_inputElm.filter(':checked').length

          if (hasRelInputElm && !hasOther) {
            formData[val.name] = '' // set other field to be empty
            return
          }
        }

        formData[val.name] = val.value
      })

      //$("body > .container, body > .outer_frame").hide();
      //$("body > .spinner").show();

      _this._showSpinner(true)

      sePlayPrv.sendForm(formData,
        function beforeSucc () {
          // vanilla event dispatch works for $().on and document.addEventListener
          UTILS.dispatchCustomEvent(document, 'seplay.page.teardown')

          $('html,body').scrollTop($('#se_title-bar').height() || 0)

          _this.resetPartial('seFooter')
        },
        function succ () { // on succ

          if (sePlayPrv.pget('header.forcedRedirect')) {
            return _this._redirect()
          }

          _this._waitForNewElementsToBeComplete().always(function () {
            _this._showSpinner(false)
          })

        },
        function err (mdl0, errObj) { // on err
          var err = errObj.error

          try {
            if (err.details.res.status === 'retry') {
              // dont fail yet. wait for retry.
              return
            } else if (err.details.res.status === 'timeout') {
              // dont fail yet. wait for retry.
              _this._showSpinner(false)
              return
            }
          } catch (err) {
            console.warn(LOG_LABEL, err)
          }

          throw err

        }
      )

      return true
    },
    doGoBack: function () {
      var _this = this

      if (sePlayPrv.pget('header.isExample')) {
        // do not send
        return
      }

      $(document).trigger('seplay.page.teardown')
      _this.resetPartial('seFooter')

      _this._showSpinner(true)

      sePlayPrv.goBack(
        function succ () { // on succ

          if (sePlayPrv.pget('header.forcedRedirect')) {
            return _this._redirect()
          }

          _this._waitForNewElementsToBeComplete().always(function () {
            _this._showSpinner(false)
          })

        },
        function err (mdl0, errObj) { // on err

          _this._showSpinner(false)
          throw errObj.error
          //seLogging.error(err);
          //_this._redirect(err);

        }
      )
    },

    doReload: function () {
      location.reload()
    },

    doCopyShareUriToClipboard: function (shareUri) {

      Copy.copyToClipboard(shareUri, 'Share URL copied to clipboard!')

      return false

    },

    // events
    oninit: function () {
      var _this = this

      _this._setupOnErrorHandling()

      _this.set('play', sePlayPrv)

      _this.set('page', sePlayPrv.page)
      _this.set('index', sePlayPrv.index)
      _this.set('pages', sePlayPrv.index.pages)

      if (sePlayPrv.page.language) {
        sePlayPrv.page.language.on('hasLoaded', function () {
          _this._showSpinner(true)

          _this._waitForNewElementsToBeComplete().always(function () {
            _this._showSpinner(false)
          })
        })
      }

      //_this.observe("play.status", _this._delayStatus);

      _this.observe('play.header.pageId', _this._updateCurrentPageNr)

      _this._rewriteUrl()
      _this._setTitle()

    },
    onrender: function () {
      var _this = this

      // Sticky Progress Bar
      $('#se_progress-bar').sticky({ topSpacing: 0 })

      // margin for preview-nav-bar
      if (_this.get('play.header.isPreview') && !_this.get('play.header.hideControls')) {
        $('body').addClass('showing_page_nav')
      }

      // "select-all" on enter for preview-url
      $('.select-all').on('focus click', function (ev) {
        var field = $(this)
        field.select()
      })

      // Capture FORM-submit
      $('form').on('submit', function (ev) {
        if (_this.doSendForm(ev.target)) {
          ev.preventDefault()
          return false
        }
      })

      if (sePlayPrv.pget('header.isExample')) {
        sePlayPrv.pset('header.progress', 33)
      }

      _this._waitForNewElementsToBeComplete().always(function () {
        loadr.hide()
      })

    },

    oncomplete: function () {
      var _this = this
    }
  })

  return PlayView

})


;
